<template>
  <div>
    <v-card class="" v-if="farmLoc && !myloadingvariable">
      <l-map
        ref="mymap"
        :zoom="zoom"
        :center="getMapCenter(farmLoc[farmLoc.length - 1].location)"
        style="height:700px; width: 100%"
      >
        <l-tile-layer :url="url" />
        <l-marker
          v-for="(loc, i) in farmLoc"
          :key="i"
          :lat-lng="getLocation(loc.location)"
        >
          <l-tooltip
            :options="{
              permanent: true,
              interactive: true,
            }"
          >
            <div>{{ loc.farm_id }}</div>
          </l-tooltip>
        </l-marker>
      </l-map>
      <!-- </div> -->
    </v-card>
    <v-container class="indicator" v-if="myloadingvariable">
      <v-progress-circular
        :size="50"
        :width="5"
        color="orange"
        indeterminate
      ></v-progress-circular>
    </v-container>
  </div>
</template>

<script>
// import axios from "axios";
import axios from "axios";
import { latLng } from "leaflet";
import { LMap, LTileLayer, LTooltip } from "vue2-leaflet";

export default {
  components: {
    LMap,
    LTileLayer,
    LTooltip,
  },
  data: () => ({
    total_distance: 0,
    myloadingvariable: true,
    alert: {
      color: "info",
      title: null,
      message: null,
      type: null,
    },
    isLoading: true,
    circle: {
      center: [47.41322, -1.0482],
      radius: 2,
      color: "red",
    },
    // map
    zoom: 6,

    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    attribution:
      '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    marker: latLng(47.41322, -1.219482),
    farmLoc: [],
    editedIndex: -1,
    editedItem1: {
      date: new Date().toISOString().substr(0, 10),
    },
  }),
  computed: {},
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  created() {
    this.initialize();
  },
  mounted() {
    this.$refs.mymap.mapObject._onResize();
  },
  methods: {
    initialize() {
      this.myloadingvariable = true;
      axios
        .get("farm/all")
        .then((res) => {
          this.farmLoc = res.data;
          this.myloadingvariable = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getLocation(loc) {
      return latLng(loc.lat, loc.long);
    },
    getMapCenter(loc) {
      return [loc.lat, loc.long];
    },
    modalShown() {
      setTimeout(() => {
        this.$refs.mymap.mapObject.invalidateSize();
      }, 100);
    },
    onResize() {
      this.$refs.mymap.mapObject.invalidateSize();
    },
  },
};
</script>

<style lang="scss">
.vue2leaflet-map {
  z-index: 1;
}
.v-stepper {
  box-shadow: none;
}

.foobar1 {
  width: 100%;
  height: 500px;
}
.v-progress-circular {
  position: absolute;
  top: 100%;
  left: 50%;
}
.indicator {
  height: 40vh;
}
.rotate {
  position: absolute;
  right: 1%;
  bottom: 1%;
  z-index: 10;
}
</style>
